export const gumletLoader = ({ src, width, quality }: any) => {
    return `https://gs-website.gumlet.io/${src}?w=${width}&q=${quality || 75}`
}

export const outSkillGumletLoader = ({ src, width, quality }: any) => {
    return `https://outskill-mentors.gumlet.io/${src}?w=${width}&q=${quality || 75}`
} 